import { render, staticRenderFns } from "./EmptyPaginationCollection.vue?vue&type=template&id=32535a07&"
import script from "./EmptyPaginationCollection.vue?vue&type=script&lang=js&"
export * from "./EmptyPaginationCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
